<template>
  <div>
    <el-form class="user-basic" ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <el-form-item class="avatar-form-item" label="头像">
        <el-upload ref="uploadAvatar" action="" :show-file-list="false" :http-request="httpRequest">
          <div class="avatar-box">
            <el-avatar :size="120" shape="square" :src="form.avatar | filterUrl">
              <img src="~@/assets/imgs/user_icon.png" alt=""/>
            </el-avatar>
            <p class="text-c avatar-footer">修改头像</p>
            <el-input disabled v-model="form.avatar"></el-input>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="用户名">
        <el-input disabled placeholder="请输入用户名" v-model="form.username"></el-input>
      </el-form-item>

      <el-form-item label="姓名" prop="nickname">
        <el-input placeholder="请输入姓名" v-model="form.nickname"></el-input>
      </el-form-item>

<!--      <el-form-item label="姓名">-->
<!--        <el-input placeholder="请输入姓名" v-model="form.name" />-->
<!--      </el-form-item>-->

      <el-form-item label="性别" prop="sex">
        <el-radio-group v-model.number="form.sex">
<!--          <el-radio :label="0">保密</el-radio>-->
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>

<!--      <el-form-item label="手机" prop="mobile">-->
<!--        <el-input placeholder="请输入手机号" v-model="form.mobile"></el-input>-->
<!--      </el-form-item>-->

<!--      <el-form-item label="邮箱" prop="email">-->
<!--        <el-input placeholder="请输入邮箱" v-model="form.email" :disabled="emailActivation"></el-input>-->
<!--      </el-form-item>-->

      <el-form-item class="form-footer">
        <el-button type="primary" :disabled="!canSubmit" @click="onSubmit('form')">保存</el-button>
        <el-button @click="$refs['form'].resetFields()">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- <wecat-login-dialog :visible.sync="dialogVisible" type="bind" :redirect="$route.fullPath"/> -->
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import {updateUserBase, getCurUserInfo, emailChange, duplicateCheck} from '@/api/system/user'
import {uploadFile} from '@/api/file'

const TIME_COUNT = 60 // 倒计时的时间
export default {
  components: {
  },
  data () {
    let checkPhone = (rule, mobile, callback) => {
      if (!mobile || mobile === "") {
        callback(new Error("请输入手机号!"));
      } else if (!/^1[3456789]\d{9}$/.test(mobile)) {
        callback(new Error("手机号码有误，请重填!"));
      } else {
        // 远程验证手机号是否存在
        duplicateCheck({
          id: this.userInfo.id,
          mobile
        }).then(res => {
          if (res) callback(new Error("手机号已存在，请重新输入!"));
          callback();
        });
      }
    };
    let checkEmail = (rule, email, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!mailReg.test(email)) {
        callback(new Error('请输入正确的邮箱格式'))
      } else if (!email || email === "") {
        callback(new Error('请输入正确的邮箱格式'))
      } else {
        duplicateCheck({
          id: this.userInfo.id,
          email
        }).then(res => {
          if (res) callback(new Error("邮箱已存在，请重新输入!"));
          callback();
        });
      }
    }
    return {
      form: {},
      send: true,
      dialogVisible: false,
      count: '',
      authCodeTimer: null,
      rules: {
        nickname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        sex: [{ required: false, message: '请选择性别', trigger: 'blur' }],
        mobile: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {validator: checkPhone, trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {validator: checkEmail, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    canSubmit() {
      let arrKey = ['nickname', 'avatar', 'mobile', 'email']
      let form = this.form
      let userInfo = this.userInfo
      for (let i = 0; i < arrKey.length; i++) {
        if (form[arrKey[i]] !== userInfo[arrKey[i]]) {
          return true
        }
      }
      return false
    },
    emailActivation() {
      return this.userInfo.emailActivation === 1
    },
    tableData() {
      return [
        {
          name: "微信",
          bind: this.userInfo.wechat || false,
        }
      ]
    },
  },
  created() {
    const {avatar, email, id, mobile, nickname, name, username, sex} = this.userInfo
    this.form = {avatar, email, id, mobile, nickname, name, username, sex}
  },
  methods: {
    ...mapActions(['setUserinfo']),
    emailChange(data, flag) {
      let params = {
        username: data.username,
        password: data.password1,
        email: data.email
      };
      if (data.authcode) params.code = data.authcode;
      emailChange(params)
          .then(() => {
            if (flag) this.$message.success("邮箱更换成功!");
          })
          .catch(() => {
          });
    },
    activeAuthCode(data) {  //修改邮箱
      this.emailChange(data, true)
    },
    getAuthCode(data) {   //发送邮箱验证码
      if (!this.authCodeTimer) {
        this.count = TIME_COUNT
        this.send = false
        this.emailChange(data)
        this.authCodeTimer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.send = true
            clearInterval(this.authCodeTimer)
            this.authCodeTimer = null
          }
        }, 1000)
      }
    },
    updateBase (obj) {
      updateUserBase(obj)
          .then(() => {
            getCurUserInfo().then(userInfo => {
              this.form = { ...userInfo }
              this.setUserinfo(userInfo)
              this.$message.success('修改成功!')
            })
          })
    },
    // 文件上传 - 覆盖默认的上传行为，可以自定义上传的实现
    httpRequest(param) {
      let fileObj = param.file
      if ((Number(fileObj.size) / 1024 / 1024).toFixed(2) > 2) {
        this.$message.warning('上传图片大小不能超过2M!')
        this.$refs['uploadAvatar'].clearFiles()
      } else {
        uploadFile(fileObj)
            .then((res = {
              originalPath: undefined
            }) => {
              this.form.avatar = res.originalPath
            })
        this.$refs['uploadAvatar'].clearFiles()
      }
    },
    onSubmit (formName) {
      const formRef = this.$refs[formName]
      formRef.validate(valid => {
        if (valid) {
          const { model } = formRef
          this.updateBase(Object.assign({}, model))
        } else {
          this.$message.error('请完整填写表单')
          return false
        }
      })
    },
  }
}
</script>

<style lang="scss">
.user-basic {
  padding: 36px 60px 30px 0;

  .avatar-form-item {
    .el-form-item__label {
      line-height: 120px;
    }
  }

  .form-footer {
    .el-button {
      &--default {
        color: #999;
      }

      & + .el-button {
        margin-left: 24px;
      }
    }
  }
}
</style>
